import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import KTFormInput, { KTFormInputType } from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ChargingPartnerDropdown from '../ChargingPartnerDropdown';

DialogAddIdentifierView.propTypes = {
  item: PropTypes.object,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogAddIdentifierView({ item, onCancel, onDone }) {
  const editMode = !!item;
  const { user } = useSelector((state) => state.auth);
  const isVoucherPartnerAccount = user?.agency?.primaryRole === 'VOUCHER_PARTNER';
  const [loading, setLoading] = useState(false);
  const [readyToValidate, setReadyToValidate] = useState(false);
  const [code, setCode] = useState('');
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [vehicleId, setVehicleId] = useState(null);
  const [selectedChargingPartner, setSelectedChargingPartner] = useState(null);

  useEffect(() => {
    setCode(item?.code ?? '');
    const vId = item?.vehicleId ?? item?.vehicle?.vehicleId ?? item?.vehicle?.id ?? null;
    const vName = item?.vehicle?.plate ?? (Utils.isValid(vId) ? String(vId) : null);
    setSelectedVehicle(Utils.isValid(vId) ? { id: vId, name: vName } : null);
    setVehicleId(Utils.isValid(vId) ? vId : null);
  }, [item]);

  useEffect(() => {
    const vehicleIdentityPartnerId =
      item?.vehicleIdentityPartnerId ??
      item?.vehicleIdentityPartner?.vehicleIdentityPartnerId;
    if (vehicleIdentityPartnerId) {
      setSelectedChargingPartner({
        id: vehicleIdentityPartnerId,
        name: item?.vehicleIdentityPartner?.name ?? vehicleIdentityPartnerId,
        partnerType: 'VEHICLE_IDENTITY_PARTNER',
      });
    } else if (item?.voucherPartnerId) {
      setSelectedChargingPartner({
        id: item.voucherPartnerId,
        name: item?.voucherPartner?.name ?? item.voucherPartnerId,
        partnerType: 'VOUCHER_PARTNER',
      });
    } else {
      setSelectedChargingPartner(null);
    }
  }, [item]);

  const handleSubmit = async () => {
    setReadyToValidate(true);
    if (!Utils.isValid(code?.trim())) {
      ToastHelper.showError('Vui lòng nhập mã MAC/EVCC');
      return;
    }
    const partnerParams =
      selectedChargingPartner?.partnerType === 'VEHICLE_IDENTITY_PARTNER'
        ? { vehicleIdentityPartnerId: _.toNumber(selectedChargingPartner.id) }
        : selectedChargingPartner?.partnerType === 'VOUCHER_PARTNER'
          ? { voucherPartnerId: _.toNumber(selectedChargingPartner.id) }
          : {};
    const params = Utils.filterParams({
      code: code.trim(),
      status: item?.status ?? ChargeConstants.ChargeIdentifierStatus.ACTIVE,
      vehicleId: vehicleId,
      ...partnerParams,
    });
    setLoading(true);
    try {
      let res;
      if (editMode) {
        res = await ChargeHelper.API.Identifier.requestUpdateIdentifier(item.vehicleIdentityId, params);
        if (res === true) {
          ToastHelper.showSuccess('Cập nhật mã định danh thành công');
          if (onDone) onDone();
        } else {
          ToastHelper.showError(_.isString(res) ? res : 'Cập nhật mã định danh thất bại');
        }
      } else {
        res = await ChargeHelper.API.Identifier.requestAddIdentifier(params);
        if (res === true) {
          ToastHelper.showSuccess('Thêm mã định danh thành công');
          if (onDone) onDone();
        } else {
          ToastHelper.showError(_.isString(res) ? res : 'Thêm mã định danh thất bại');
        }
      }
    } catch {
      ToastHelper.showError('Có lỗi xảy ra');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="d-flex flex-column gap-0 px-4 mt-4">
        <div className="mb-4">
          {UIHelper.buildFormLabel('Mã MAC/EVCC', true)}
          <KTFormInput
            type={KTFormInputType.text}
            placeholder="Nhập mã MAC/EVCC"
            name="code"
            value={code}
            onChange={(value) => setCode(value)}
            enableCheckValid={readyToValidate}
            isValid={Utils.isValid(code?.trim())}
            isTouched={readyToValidate}
            feedbackText={!Utils.isValid(code?.trim()) ? 'Vui lòng nhập mã MAC/EVCC' : ''}
            // disabled={editMode}
          />
        </div>

        <div className="mb-4">
          {UIHelper.buildFormLabel('Đối tác sạc')}
          <ChargingPartnerDropdown
            id="chargingPartner_dialog"
            name="chargingPartner_dialog"
            selectedValue={selectedChargingPartner}
            onChange={(value) => setSelectedChargingPartner(value ?? null)}
          />
        </div>

        <div className="mb-4">
          {UIHelper.buildFormLabel('Chọn xe')}
          <CustomDropdown2
            id="vehicleId_dialog"
            name="vehicleId_dialog"
            ignoreConfirmClick={true}
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                type="button"
              >
                {selectedVehicle?.name ?? 'Chọn xe'}
              </button>
            }
            selectedValue={selectedVehicle}
            dropdownMenuItems={[{ name: 'Xe', role: 'VEHICLE' }]}
            getSubItems={async (dropdownItem) => {
              return ChargeHelper.API.Vehicle.requestGetVehicleList({
                page: dropdownItem?.page || 0,
                limit: 10,
                q: dropdownItem?.q || '',
                vehicleIdentityId: 'null',
              }).then((data) => ({
                values: data.vehicles?.map((row) => ({
                  id: row?.vehicleId,
                  name: row?.plate,
                  item: row,
                })),
                total: data.total,
              }));
            }}
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            dropdownMenuClassName="overflow-auto w-100"
            onChange={(value) => {
              setSelectedVehicle(value);
              setVehicleId(value?.id ?? value?.item?.vehicleId ?? null);
            }}
            isDropdownForm={true}
            titleSearchable={true}
            searchable={true}
            searchFormClassName="mx-3 my-1 search-form-border"
            defaultValue={{ name: 'Xe', role: 'VEHICLE' }}
            footerEl={
              <div
                className="p-4 position-sticky sticky-bottom bg-white"
                style={{ borderTop: `1px solid ${AppColors.gray[300]}` }}
              >
                {UIHelper.buildNegativeButton('Bỏ chọn', () => {
                  setSelectedVehicle(null);
                  setVehicleId(null);
                })}
              </div>
            }
          />
        </div>
      </div>
      <div
        className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
        style={{ borderTop: `1px solid ${AppColors.gray[200]}` }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
        {UIHelper.buildGreenButton(
          !editMode ? 'Thêm' : 'Cập nhật',
          handleSubmit,
          null,
          false,
          loading
        )}
      </div>
    </div>
  );
}

export default DialogAddIdentifierView;
